// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"795acc02","492":"60c0f033","532":"6015c1ab","640":"3b149faf","647":"56af2fcf"}[chunkId] + ".chunk.js";
};